import { OutputEmitterRef } from '@angular/core';

export class ToastRef {
  constructor(
    public closed: OutputEmitterRef<void>,
    protected closeFn: () => void,
  ) {}

  close(): void {
    this.closeFn();
  }
}
